export default function Question({ question, module, answer, onAnswer }) {
  if (module === 'oir') {
    return (
      <div className="card">
        <h3 className="text-lg font-semibold mb-4">{question.text}</h3>
        <div className="space-y-3">
          {question.options.map((option, index) => (
            <button
              key={index}
              onClick={() => onAnswer(option)}
              className={`w-full p-4 border-2 rounded-lg text-left transition-all ${
                answer === option
                  ? 'border-primary-600 bg-primary-50 dark:bg-primary-900/20'
                  : 'border-gray-300 dark:border-gray-600 hover:border-primary-400 hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    )
  }

  if (module === 'wat') {
    return (
      <div className="card">
        <div className="text-center mb-6">
          <h3 className="text-4xl font-bold text-primary-600 uppercase mb-2">
            {question.word}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Write a meaningful sentence using this word
          </p>
        </div>
        <textarea
          value={answer || ''}
          onChange={(e) => onAnswer(e.target.value)}
          placeholder="Type your sentence here..."
          className="textarea-field"
          rows="3"
        />
      </div>
    )
  }

  if (module === 'tat') {
    return (
      <div className="card">
        <h3 className="text-lg font-semibold mb-3">{question.title}</h3>
        <div className="aspect-video bg-gray-200 dark:bg-gray-700 rounded-lg mb-4">
          {/* Image placeholder - would show actual image in production */}
          <div className="w-full h-full flex items-center justify-center text-gray-500">
            TAT Image: {question.id}
          </div>
        </div>
        <textarea
          value={answer || ''}
          onChange={(e) => onAnswer(e.target.value)}
          placeholder="Write your story here (include Situation, Task, Action, Result)..."
          className="textarea-field"
          rows="6"
        />
        <p className="text-xs text-gray-500 mt-2">
          Word count: {(answer || '').trim().split(/\s+/).filter(w => w.length > 0).length}
        </p>
      </div>
    )
  }

  if (module === 'srt') {
    return (
      <div className="card">
        <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg mb-4">
          <p className="text-gray-800 dark:text-gray-200">{question.text}</p>
        </div>
        <textarea
          value={answer || ''}
          onChange={(e) => onAnswer(e.target.value)}
          placeholder="Write your immediate reaction..."
          className="textarea-field"
          rows="4"
        />
      </div>
    )
  }

  return null
}
